require('./bootstrap');
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import App from './components/App.vue';
import router from "./routes";

const pinia = createPinia();

const app = createApp(App);
app.use(router);
app.use(Toast);
app.use(pinia);

app.mount('#app');
